<script setup lang="ts">
import type { IOfferPrimaryCardCredit } from './types'
import { UiCardTop } from '~/components/ui/card'
import { Button } from '~/components/ui/button'
import { ANCHOR_IDS } from '~/lib/constants'

const props = defineProps<IOfferPrimaryCardCredit>()
</script>

<template>
  <article
    class="PrimaryCard"
    :class="{
      '!border-orange-600 hover:!border-blue-600 [&>span]:hover:bg-blue-600': props.isTop
    }"
  >
    <UiCardTop v-if="props.isTop" />
    <header>
      <div class="flex items-center gap-2 rounded-lg">
        <figure class="flex-shrink-0 rounded-lg">
          <NuxtImg
            :src="props.companyLogo"
            width="40"
            height="40"
            class="min-w-5"
            :alt="props.companyName"
          />
        </figure>
        <div class="flex w-full flex-col gap-0.5">
          <span class="text-sm">{{ props.companyName }}</span>
          <div class="mt-0.5 font-semibold">{{ props.title }}</div>
        </div>
      </div>
      <Heading tag="h3" class="h5 mt-2">
        <div v-html="props.rate" />
      </Heading>
      <div class="flex items-center justify-between">
        <span class="text-sm">{{ props.period }}</span>
        <Button
          as-child
          size="sm"
          variant="blue"
          :aria-label="$t('common.detailsAbout', { title: props.title })"
        >
          <NuxtLinkLocale
            :to="{
              path: props.url,
              hash: `#${ANCHOR_IDS.FEATURE_CREDIT_FORM_REQUEST}`
            }"
          >
            {{ $t('common.more_details') }}
          </NuxtLinkLocale>
        </Button>
      </div>
    </header>
  </article>
</template>
